const NAMESPACE = "communicationSavingHelper";

const KEYS = {
    templateErrorDialogTitle: "templateErrorDialogTitle",
    referencesErrorDialogMessagesLabel: "referencesErrorDialogMessagesLabel",
    communicationTagErrorsDialogInfoMsg: "communicationTagErrorsDialogInfoMsg",
    announcementTagErrorsDialogInfoMsg: "announcementTagErrorsDialogInfoMsg",
    formLinkErrorsDialogTitle: "formLinkErrorsDialogTitle",
    formStatusMappingConflictDialogTitle: "formStatusMappingConflictDialogTitle",
    formStatusMappingConflictDialogContinueBtnLabel: "formStatusMappingConflictDialogContinueBtnLabel",
    invalidEmailAddressesForAnnouncementsMessage: "invalidEmailAddressesForAnnouncementsMessage",
    invalidEmailAddressesForCommunicationMessage: "invalidEmailAddressesForCommunicationMessage",
    missingSubjectMessage: "missingSubjectMessage",
    missingContentMessage: "missingContentMessage",
    availableToAllStatuses: "availableToAllStatuses",
    availableToNoStatuses: "availableToNoStatuses",
    availableToOneStatus: "availableToOneStatus",
    availableToSomeStatuses: "availableToSomeStatuses",
    andText: "andText"
};

const MESSAGES = {
    [KEYS.templateErrorDialogTitle]: {
        value: "Unable to Save Template",
        comment: "Title for dialog that displays reasons the template couldn't be saved"
    },
    [KEYS.referencesErrorDialogMessagesLabel]: {
        value: "Errors:",
        comment: "Label for error messages that prevented saving the template"
    },
    [KEYS.communicationTagErrorsDialogInfoMsg]: {
        value: "Please correct the following template tag errors in this communication before saving.",
        comment: "Info message for tag errors dialog for communication templates"
    },
    [KEYS.announcementTagErrorsDialogInfoMsg]: {
        value: "Please correct the following template tag errors in this announcement before saving.",
        comment: "Info message for tag errors dialog for announcement templates"
    },
    [KEYS.formStatusMappingConflictDialogTitle]: {
        value: "Form Status Mapping Conflict",
        comment:
            "Title for dialog for form links having conflicting status mappings from the communication status mapping"
    },
    [KEYS.formStatusMappingConflictDialogContinueBtnLabel]: {
        value: "Continue Saving",
        comment: "Label for continue saving button on form link error dialog"
    },
    [KEYS.invalidEmailAddressesForAnnouncementsMessage]: {
        value: "An announcement template's recipient must be a single valid template tag (e.g. {data:XXXXX} or {AssigneeEmail} or {ProjectOwnerEmail}).",
        comment:
            "Error text for when an announcement has an invalid recipient, either multiple addresses or a hard-coded email address"
    },
    [KEYS.invalidEmailAddressesForCommunicationMessage]: {
        value: "A communication template must have at least one recipient.",
        comment: "Error text for when a communication is missing a recipient."
    },
    [KEYS.missingSubjectMessage]: {
        value: "Cannot publish a template with an empty subject line.",
        comment: "Error text for publishing a template with an empty subject line."
    },
    [KEYS.missingContentMessage]: {
        value: "Cannot publish a template with no content.",
        comment: "Error text for publishing a template with an empty subject line."
    },
    [KEYS.availableToAllStatuses]: {
        value: "Available to all statuses.",
        comment: "Detail text for a template that is available to all statuses"
    },
    [KEYS.availableToNoStatuses]: {
        value: "Available to no statuses.",
        comment: "Detail text for a template that is available to no statuses"
    },
    [KEYS.availableToOneStatus]: {
        value: "Available to status {statusName}.",
        comment: "Detail text for a template that is only available in one status, statusName."
    },
    [KEYS.availableToSomeStatuses]: {
        value: "Available to statuses {statusNames}.",
        comment: "Detail text for a template that is only available in one status, statusName."
    },
    [KEYS.andText]: {
        value: "and",
        comment: "conjunction to append last status name to status list for detail text of statuses"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
